export default __webpack_public_path__ + "53f2f49.png";